import { baseService } from "../base";
import { Activity, GetActivitiesParams, PaginationResponse } from "./activities.type";

export const activitiesServices = {
  getActivities: async (params?: GetActivitiesParams) => {
    const { data } = await baseService.get<PaginationResponse<Activity>>(
      "/activities",
      { params }
    );
    return data;
  },

  getRecentActivities: async (limit: number = 20) => {
    const { data } = await baseService.get<Activity[]>(
      "/activities/recent",
      { params: { limit } }
    );
    return data;
  },
};
